module.exports = "pegasus/assets/themelp1/ebook/105.png";